'use strict';

// v1.1

import dispatcher from '../dispatcher';
import resizeStore from '../resize/resize.store';
import loaderStore from '../navigation/loader.store';


let html = document.documentElement,
    button,
    nav,
    navOverlay,
    windowWidth,
    scrollBarWidth = false,
    active = false,
    timer;



function _handleResize(e) {
  windowWidth = e.width;
  scrollBarWidth = window.innerWidth - windowWidth;
}



function _toggle(e) {
  e.preventDefault();
  if (e.type === 'keydown' && e.keyCode !== 13) return;

  if (navigator.vibrate) navigator.vibrate(5);

  if (!active) {
    _openMenu();
  } else {
    _closeMenu();
  }
}


function _openMenu() {
  if (active) return;

  clearTimeout(timer);

  html.classList.add('navActive');

  if (scrollBarWidth) {
    html.style.marginRight = scrollBarWidth + 'px';
    button.style.marginRight = scrollBarWidth + 'px';
    nav.style.marginRight = '';
  }

  dispatcher.dispatch({
    type: 'nav-open'
  });

  active = true;
}

function _closeMenu() {
  if (!active) return;
  clearTimeout(timer);

  html.classList.remove('navActive');
  button.style.marginRight = '';
  nav.style.marginRight = -scrollBarWidth + 'px';

  dispatcher.dispatch({
    type: 'nav-close'
  });

  active = false;
}


function init() {
  button = document.querySelector('.nav-button');

  if (!button) return;

  nav = document.querySelector('nav');
  active = html.classList.contains('navActive');
  navOverlay = document.querySelector('.nav-overlay');


  button.addEventListener('click', _toggle, false);

  if (navOverlay) navOverlay.addEventListener('click', _closeMenu, false);

  document.addEventListener('keydown', function (e) {
    if (!active || e.key === 'ESC') return;

    e.preventDefault();

    _closeMenu();
  }, false);

  dispatcher.subscribe(function (e) {
    if (e.type === 'menu-close') _closeMenu();
  });

  loaderStore.eventEmitter.subscribe(function (e) {
    if (e.type === 'load-animation-play' && e.loadAnimation === 'start-complete') _closeMenu();
  });

  _handleResize(resizeStore.getData());
  resizeStore.eventEmitter.subscribe(_handleResize);
}




export default {
  init: init
}